<template functional>
  <div class="button-loader" :style="$options.loaderStyles(props)" />
</template>

<script>
export default {
  name: 'Loader',
  props: {
    color: {
      type: String,
      required: false,
      default: '176BFA',
    },
    size: {
      type: Number,
      required: false,
      default: 22,
    },
    width: {
      type: Number,
      required: false,
      default: 2,
    },
  },
  loaderStyles: ({ color, size, width }) => ({
    'border-left': `${width}px solid #${color}`,
    'border-right': `${width}px solid transparent`,
    'border-top': `${width}px solid transparent`,
    'border-bottom': `${width}px solid transparent`,
    height: `${size}px`,
    'min-width': `${size}px`,
    width: `${size}px`,
  }),
};
</script>

<style lang="scss" scoped>
.button-loader,
.button-loader:after {
  border-radius: 50%;
}
.button-loader {
  animation: spin 1.1s infinite linear;
  background: transparent;
  margin: 0 8px 0 0;
  position: relative;
  &::before {
    animation: spin 1s linear infinite;
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
